import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatSSN'
})
export class FormatSSNPipe implements PipeTransform {
   transform(value: string | number): string {
    if (!value) return '';

    const digits = value.toString().replaceAll(/\D/g, '');

    if (digits.length !== 9) return value.toString(); // invalid, return original

    return digits.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
  }
} 